var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Prop } from 'vue-property-decorator';
import MonacoEditor from "../../../../lib/comps/MaterialBox/MonacoEditor";
import modalFactory from "../../../../lib/comps/modalFactory";
import { ArrayItemNode } from "../../../../lib/comps/DataSourceTree/ArrayItemsTree";
import "./JSONEditModal.css";
/** mock启用时 M按钮弹出的局部mock编辑菜单 */
let JSONEditModal = class JSONEditModal extends Vue {
  constructor() {
    super(...arguments);
    this.modalWidth = 60;
  }
  /** 当格式无法展示为 ArrayItemNode 时采用monaco直接展示schema*/
  get shouldRenderRawSchema() {
    return !this.schema.items;
  }
  get leftMonacoWidth() {
    return this.shouldRenderRawSchema ? 25 : 35;
  }
  get rightPanelWidth() {
    return this.modalWidth - this.leftMonacoWidth;
  }
  created() {
    this.value = this.options.source;
    if (!this.options.schema) return;
    this.schema = JSON.parse(this.options.schema);
    this.schemaString = JSON.stringify(this.schema, null, 2);
  }
  onCancel() {
    this.$emit('message', {
      success: false
    });
  }
  onOk() {
    const res = {
      success: true,
      message: 'change',
      data: {
        source: this.value
      }
    };
    this.$emit('message', res);
  }
  onDelete() {
    const res = {
      success: true,
      message: 'delete'
    };
    this.$emit('message', res);
  }
  render() {
    const h = arguments[0];
    return h("a-modal", {
      "attrs": {
        "width": `${this.modalWidth}vw`,
        "title": `局部mock编辑 路径=${this.options.path}`,
        "visible": true
      },
      "on": {
        "cancel": this.onCancel,
        "ok": this.onOk
      }
    }, [h("div", {
      "class": "jsonEditModal-subTitle"
    }, [h("div", {
      "class": "leftTitle",
      "style": `width:${this.leftMonacoWidth}vw`
    }, [h("div", ["mock\u6570\u636E"]), this.options.schemaPath !== undefined && h("a-button", {
      "style": "margin-left:10px",
      "attrs": {
        "type": "primary"
      },
      "on": {
        "click": this.onDelete
      }
    }, ["\u5173\u95ED\u5F53\u524D\u8DEF\u5F84\u7684mock"])]), h("div", {
      "class": "leftTitle"
    }, [" mock\u6570\u636E\u683C\u5F0F"])]), h("div", {
      "class": "jsonEditModal-container"
    }, [h(MonacoEditor, {
      "style": `height:60vh;width:${this.leftMonacoWidth}vw`,
      "model": {
        value: this.value,
        callback: $$v => {
          this.value = $$v;
        }
      }
    }), this.shouldRenderRawSchema && h(MonacoEditor, {
      "attrs": {
        "initOptions": {
          readOnly: true
        }
      },
      "style": `width:${this.rightPanelWidth}vw`,
      "model": {
        value: this.schemaString,
        callback: $$v => {
          this.schemaString = $$v;
        }
      }
    }), !this.shouldRenderRawSchema && h(ArrayItemNode, {
      "class": "mock-jsonModal-dataTree",
      "attrs": {
        "schema": this.schema,
        "showChildrenOnly": true
      }
    })])]);
  }
};
__decorate([Prop()], JSONEditModal.prototype, "options", void 0);
JSONEditModal = __decorate([Component({
  name: 'JSONEditModal',
  components: {}
})], JSONEditModal);
const open = modalFactory(JSONEditModal);
export const openJSONEditModal = async options => await open(options);
//# sourceMappingURL=JSONEditModal.js.map
